<script>

    import { toast } from 'bulma-toast'
    import { userStore, chargesStore, modalStore } from '../stores'

    import ChargesService from '../$services/charges.service'
    import DateMethod from '../$methods/date.method'
    import NumeralMethods from '../$methods/numeral.methods'
    import TranslateMethods from '../$methods/translate.methods.js'

    import Pagination from '../$components/pagination.svelte'
    import Search from '../$components/input.search.svelte'
    import Table from '../$components/table.svelte'
    import ButtonModal from '../$components/button.modal.svelte'
    import Button from '../$components/button.svelte'
    import Select from '../$components/select.svelte'

    export let all = false

    let query = {
        page: 0,
        find: null
    }
    let metadata = {}
    let loading = false

    getCharges()

    async function getCharges() {

        if(all)
            query.admin = true
        else
            query.userId = $userStore._id

        loading = true
        const resp = await ChargesService.getCharges(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        chargesStore.set(resp.data.charges)
        metadata = resp.data.metadata
    }

</script>

<Table items={ $chargesStore.length } total={ metadata.total } { loading }>
    <div slot="toolbar">
        <div class="columns is-multiline is-align-items-flex-end mb-0">
            <div class="column">
                <Search bind:value={ query.find } on:enter={ getCharges } />
            </div>
            <div class="column is-narrow">
                <Select bind:value={ query.type } on:change={ getCharges }
                    text="Tipo de cargo"
                    options={[
                        {value: 'charge', text: 'Cargo'},
                        {value: 'refund', text: 'Reembolso'}
                    ]}
                />
            </div>
            <div class="column is-narrow">
                <Select bind:value={ query.status } on:change={ getCharges }
                    text="Estatus de pago"
                    options={[
                        {value: 'pending', text: 'Pendiente'},
                        {value: 'paid', text: 'Pagado'},
                        {value: 'account', text: 'Cuenta'}
                    ]}
                />
            </div>
            {#if all || query.userId}
                <div class="column is-narrow">
                    <div class="charges-toolbar-actions">
                        {#if all}
                            <ButtonModal modalId="charges_download_modal" icon="download" text="Descargar cargos" />
                            <ButtonModal modalId="charges_upload_modal" icon="upload" text="Subir cargos" />
                        {/if}
                        {#if query.userId}
                            <ButtonModal modalId="charge_create_modal" icon="plus" text="Agregar" />
                        {/if}
                    </div>
                </div>
            {/if}
        </div>
    </div>
    <div slot="footer">
        <Pagination bind:metadata bind:page={ query.page } on:change={ getCharges } />
    </div>
    <thead>
        <tr>
            <th>#</th>
            <th>Usuario</th>
            <th>Estatus</th>
            <th>Tipo</th>
            <th>Concepto</th>
            <th>Monto</th>
            <th>Fecha</th>
            <th class="has-text-right">Acciones</th>
        </tr>
    </thead>
    <tbody>
        {#each $chargesStore as charge, index}
            <tr>
                <td>{(metadata.items * query.page) + (index + 1)}</td>
                <td>
                    <div>
                        <div>{charge.user.name}</div>
                        <div>{charge.user.email}</div>
                    </div>
                </td>
                <td>{TranslateMethods.get(charge.status)}</td>
                <td>{TranslateMethods.get(charge.type)}</td>
                <td>{charge.concept}</td>
                <td>{NumeralMethods.cash(charge.amount)}</td>
                <td>{DateMethod.dateTimeLarge(charge.created)}</td>
                <td>
                    <Button on:click={() => modalStore.open('charge', 'modal', charge)} icon="ellipsis-v" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>
